
import React, { useEffect, useState } from 'react';
import { images } from '../../utils/images';
import { useLocation } from "react-router-dom";
import { ERROR_IMAGE_TYPE } from '../../utils/const';


export const ErrorScreen = () => {

    const [params, setParams] = useState({errorImgType: ERROR_IMAGE_TYPE.INFO, title: 'Có lỗi xảy ra. Xin vui lòng thử lại sau', subTitle: '', buttonText: ''});
    const location = useLocation();


    const getErrorImgByType = (type) => {
        switch (type) {
            case ERROR_IMAGE_TYPE.INFO:
                return images.img_thum_info;
            case ERROR_IMAGE_TYPE.TIME:
                return images.img_thum_time;
            case ERROR_IMAGE_TYPE.DOWNLOAD:
                return images.img_thum_download;
            default:
                return images.img_thum_info;
        }
    }

    useEffect(() => {
        if (location && location.state) {
            setParams({...location.state})
        }
    }, [location])
    
    const onButtonClick = () => {
        //ZaloPaySDK.closeApp();
    }

    return (
        <div className={'mobile-container flex-v-center column'} style={{backgroundColor: '#1890ff', height: '100vh'}}>
            <div className={'font-family-display font-weight-bold font-size-18 line-height-22 text-align-center margin-top-24'} style={{color:"#ffffff", marginTop:"30%"}}>{params.title}</div>
            <div className={'font-family-display font-size-14 line-height-18 text-align-center color-white margin-top-8'}>{params.subTitle}</div>
        </div>
    )
}